export default __webpack_public_path__ + "static/media/eng_green.fde510d8.svg";